<template>
  <div class="InfoReplenish">
    <el-dialog
      title="企业信息补充"
      :visible.sync="centerDialogVisible"
      center
      width="70%"
    >
      <div class="companyInfo">
        <h3 class="cName">{{companyInfo.unitName}}</h3>
        <p>统一社会信用代码：<span>{{companyInfo.property1}}</span></p>
        <p>注册地区：<span>{{companyInfo.reg_location}}</span></p>
      </div>
      <el-tabs class="formTab" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane class="tabTitle" label="基础信息" name="first">
          <el-form class="baseForm" label-position="left" label-width="80px" :model="baseInfo">
            <div class="formInline">
              <el-form-item label="所属区域">
                <el-cascader :options="areaOptions" clearable placeholder="请选择所属区域"></el-cascader>
              </el-form-item>
              <el-form-item label="注册日期">
                <el-date-picker v-model="baseInfo.registerDate" type="date" placeholder="请选择注册日期"></el-date-picker>
              </el-form-item>
            </div>
            <div class="formInline">
              <el-form-item label="所属产业">
                <el-select v-model="baseInfo.industry" placeholder="请选择所属产业">
                  <el-option
                    v-for="item in industryOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属行业">
                <el-select v-model="baseInfo.business" placeholder="请选择所属行业">
                  <el-option
                    v-for="item in businessOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="formInline">
              <el-form-item label="注册类型">
                <el-select v-model="baseInfo.type" placeholder="请选择注册类型">
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="主体分类">
                <el-select v-model="baseInfo.classify" placeholder="请选择主体分类">
                  <el-option
                    v-for="item in classifyOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="formInline">
              <el-form-item label="企业规模">
                <el-select v-model="baseInfo.scale" placeholder="请选择企业规模">
                  <el-option
                    v-for="item in scaleOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="资质荣誉">
                <el-select v-model="baseInfo.honor" placeholder="请选择资质荣誉">
                  <el-option
                    v-for="item in honorOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <el-form-item style="text-align: center;">
              <el-button type="primary" @click="nextOne">下一步</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane class="tabTitle" label="经营情况" name="second">
          <el-form class="manageForm" label-position="left" label-width="80px" :model="manageInfo">
            <div class="formInline">
              <el-form-item label="上年度主营业务收入">
                <el-input v-model="manageInfo.income" placeholder="请输入上年度主营业务收入"></el-input>
              </el-form-item>
              <el-form-item label="上年度纳税总额">
                <el-input v-model="manageInfo.tax" placeholder="请输入上年度纳税总额"></el-input>
              </el-form-item>
            </div>
            <div class="formInline">
              <el-form-item label="上年度研发投入">
                <el-input v-model="manageInfo.putInto" placeholder="请输入上年度研发投入"></el-input>
              </el-form-item>
              <el-form-item label="上年度净利润">
                <el-input v-model="manageInfo.profit" placeholder="请输入上年度净利润"></el-input>
              </el-form-item>
            </div>
            <div class="formInline">
              <el-form-item label="涉及领域">
                <el-select v-model="manageInfo.domain" placeholder="请选择涉及领域">
                  <el-option
                    v-for="item in domainOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item></el-form-item>
            </div>
            <el-form-item style="text-align: center;">
              <el-button type="primary" @click="upOne">上一步</el-button>
              <el-button type="primary" @click="nextTwo">下一步</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane class="tabTitle" label="科研情况" name="third">
          <el-form class="scientificForm" label-position="left" label-width="80px" :model="scientificInfo">
            <div class="formInline">
              <el-form-item label="自主知识产权数量">
                <el-input v-model="scientificInfo.knowledgeNum" placeholder="请输入自主知识产权数量" type="number"></el-input>
              </el-form-item>
              <el-form-item label="创新孵化载体类型">
                <el-select v-model="scientificInfo.carrierType" placeholder="请选择创新孵化载体类型">
                  <el-option
                    v-for="item in carrierOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="formInline">
              <el-form-item label="研发人员数量">
                <el-input v-model="scientificInfo.personNum" placeholder="请输入研发人员数量" type="number"></el-input>
              </el-form-item>
              <el-form-item label="科技奖项">
                <el-select v-model="scientificInfo.awards" placeholder="请选择科技奖项">
                  <el-option
                    v-for="item in awardsOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <el-form-item style="text-align: center;">
              <el-button type="primary" @click="upTwo">上一步</el-button>
              <el-button type="primary" @click="submitForm">提交</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs> 
    </el-dialog>
  </div>
</template>
<script>

export default {
  name: "InfoReplenish",
  data() {
    return {
      centerDialogVisible: false,
      activeName : 'first',
      companyInfo:{
        unitName:"",
        property1:"",
        reg_location:"",
      },
      baseInfo: { // 基础信息
        registerDate: '', 
        industry:'',
        business:'',
        type:'',
        classify:'',
        scale:'',
        honor:''
      },
      manageInfo:{
        income:'',
        tax:'',
        putInto:'',
        profit:'',
        domain:''
      },
      scientificInfo:{
        knowledgeNum:'',
        carrierType:'',
        personNum:'',
        awards:'',
      },
      areaOptions: [{
        value: '1',
        label: '北京市',
        children: [{
          value: '1-1',
          label: '北京市',
          children: [{
            value: '1-1-1',
            label: '海淀区'
          }, {
            value: '1-1-2',
            label: '朝阳区'
          }, {
            value: '1-1-3',
            label: '东城区'
          }, {
            value: '1-1-4',
            label: '西城区'
          }]
        }],
      },{
        value: '2',
        label: '河北省',
        children: [{
          value: '2-1',
          label: '石家庄市',
          children: [{
            value: '2-1-1',
            label: '长安区'
          }, {
            value: '2-1-2',
            label: '桥西区'
          }, {
            value: '2-1-3',
            label: '新华区'
          }]
        },{
          value: '2-2',
          label: '唐山市',
          children: [{
            value: '2-2-1',
            label: '路南区'
          }, {
            value: '2-2-2',
            label: '路北区'
          }, {
            value: '2-2-3',
            label: '古治区'
          }]
        }],
      }],
      industryOptions: [{
          value: '0',
          label: '不限'
      },{
          value: '1',
          label: '新一代信息技术产业'
      },{
          value: '2',
          label: '数字经济产业'
      },{
          value: '3',
          label: '新材料产业'
      },{
          value: '4',
          label: '高端装备产业'
      },{
          value: '5',
          label: '绿色低碳产业'
      },{
          value: '6',
          label: '海洋经济产业'
      },{
          value: '7',
          label: '生物医药产业'
      },{
          value: '8',
          label: '高新技术产业'
      },{
          value: '9',
          label: '文化产业'
      },{
          value: '10',
          label: '旅游产业'
      },{
          value: '11',
          label: '体育产业'
      },{
          value: '12',
          label: '养老产业'
      },{
          value: '13',
          label: '健康产业'
      },{
          value: '14',
          label: '节能环保清洁产业'
      },{
          value: '15',
          label: '教育培训相关产业'
      },{
          value: '16',
          label: '生产性服务业'
      },{
          value: '17',
          label: '时尚产业'
      },{
          value: '18',
          label: '传统优势产业'
      },{
          value: '19',
          label: '集成电路产业'
      }],
      businessOptions: [{
          value: '0',
          label: '不限'
      },{
          value: '1',
          label: '农、林、牧、渔业'
      },{
          value: '2',
          label: '采矿业'
      },{
          value: '3',
          label: '电力、热力、燃气及水生产和供应业'
      },{
          value: '4',
          label: '建筑业'
      },{
          value: '5',
          label: '批发和零售业'
      },{
          value: '6',
          label: '交通运输、仓储和邮政业'
      },{
          value: '7',
          label: '住宿和餐饮业'
      },{
          value: '8',
          label: '信息传输、软件和信息技术服务业'
      },{
          value: '9',
          label: '金融业'
      },{
          value: '10',
          label: '房地产业'
      },{
          value: '11',
          label: '租赁和商务服务业'
      },{
          value: '12',
          label: '科学研究和技术服务业'
      },{
          value: '13',
          label: '水利、环境和公共设施管理业'
      },{
          value: '14',
          label: '居民服务、修理和其他服务业'
      },{
          value: '15',
          label: '教育'
      },{
          value: '16',
          label: '卫生和社会工作'
      },{
          value: '17',
          label: '文化、体育和娱乐业'
      },{
          value: '18',
          label: '公共管理、社会保障和社会组织'
      },{
          value: '19',
          label: '国际组织'
      },{
          value: '20',
          label: '制造业'
      }],
      typeOptions:[{
          value: '1',
          label: '内资企业'
      },{
          value: '2',
          label: '港澳台商投资企业'
      },{
          value: '3',
          label: '外商投资企业'
      }],
      classifyOptions:[{
          value: '1',
          label: '企业'
      },{
          value: '2',
          label: '个人'
      },{
          value: '3',
          label: '社会组织'
      },{
          value: '4',
          label: '事业单位'
      }],
      scaleOptions:[{
          value: '1',
          label: '大型'
      },{
          value: '2',
          label: '中型'
      },{
          value: '3',
          label: '小型'
      },{
          value: '4',
          label: '微型'
      }],
      honorOptions:[{
          value: '1',
          label: '电子商务示范企业'
      },{
          value: '2',
          label: '独角兽企业'
      },{
          value: '3',
          label: '国家级数字商务示范企业'
      },{
          value: '4',
          label: '电商直播基地'
      },{
          value: '5',
          label: '电子商务示范基地（园区）'
      },{
          value: '6',
          label: '全国互联网100强'
      },{
          value: '7',
          label: '跨国公司总部企业'
      },{
          value: '8',
          label: '创新创业大赛获奖企业（战略新兴产业）'
      },{
          value: '9',
          label: '国家专精特新重点小巨人（战略新兴产业）'
      },{
          value: '10',
          label: '广东省专精特新企业（战略新兴产业）'
      },{
          value: '11',
          label: '中国500强企业'
      },{
          value: '12',
          label: '世界500强企业'
      },{
          value: '13',
          label: '工业设计领军企业'
      },{
          value: '14',
          label: '知名工业设计奖'
      },{
          value: '15',
          label: '技术先进型服务企业（软件信息服务业）'
      },{
          value: '16',
          label: '国家高新技术企业（高新技术产业）'
      },{
          value: '17',
          label: '绿色工厂（制造业）'
      },{
          value: '18',
          label: '绿色产品'
      },{
          value: '19',
          label: '绿色工业园区'
      },{
          value: '20',
          label: '绿色供应链管理企业'
      },{
          value: '21',
          label: '绿色企业'
      },{
          value: '22',
          label: '绿色数据中心'
      },{
          value: '23',
          label: '自愿性清洁生产企业'
      },{
          value: '24',
          label: '工业产业绿色设计企业'
      },{
          value: '25',
          label: '国家技术创新示范企业（战略新兴产业）'
      },{
          value: '26',
          label: '工业互联网服务商培育企业（软件信息服务业）'
      },{
          value: '27',
          label: '市场准入（高端装备产业、生物医药产业）'
      },{
          value: '28',
          label: '单项冠军示范企业（战略新兴产业）'
      },{
          value: '29',
          label: '单项冠军产品（战略新兴产业）'
      },{
          value: '30',
          label: '深圳市总部企业'
      },{
          value: '31',
          label: '科技型中小企业'
      }],
      domainOptions:[{
          value: '1',
          label: '境外投资'
      },{
          value: '2',
          label: '对外承包工程'
      },{
          value: '3',
          label: '跨境电子商务'
      },{
          value: '4',
          label: '境外业务'
      },{
          value: '5',
          label: '电子商务'
      },{
          value: '6',
          label: '鼓励进口产品及技术总额不低于50万'
      },{
          value: '7',
          label: '美元'
      }],
      awardsOptions:[{
          value: '1',
          label: '科技进步奖'
      },{
          value: '2',
          label: '自然科学奖'
      },{
          value: '3',
          label: '科技发明奖'
      },{
          value: '4',
          label: '市长奖'
      }],
      carrierOptions:[{
          value: '1',
          label: '公共服务平台'
      },{
          value: '2',
          label: '专业技术服务平台'
      },{
          value: '3',
          label: '科研机构'
      },{
          value: '4',
          label: '企业研发中心'
      },{
          value: '5',
          label: '工程技术中心'
      },]
    };
  },
  methods: {
    submitForm() {
      // this.$refs["formData"].validate((valid) => {
      //   if (valid) {
      //     console.log(this.formData);
        this.$message({
          message: '提交成功',
          type: 'success'
        });
           this.centerDialogVisible = false;
      //   } else {
      //     return false;
      //   }
      // });
    },
    show(obj) {
      this.centerDialogVisible = true;
      this.companyInfo = obj;
    },
    nextOne(){
      this.activeName="second"
    },
    upOne(){
      this.activeName="first"
    },
    nextTwo(){
      this.activeName="third"
    },
    upTwo(){
      this.activeName="second"
    },
    handleClick(){

    }
  },
};
</script>
<style lang="scss" scoped>
.InfoReplenish {
  /deep/.el-dialog__title{
    font-weight: bold;
    font-size: 24px;
  }
  /deep/.el-dialog{
    height:560px;
  }
  .companyInfo{
    color: #333;
    padding: 5px;
    margin-bottom: 10px;
    margin-left: 10px;
    box-sizing: border-box;
    letter-spacing: 1px;
    *{
      padding: 0;
      margin: 0;
    }
    .cName{
      font-size: 22px;
      line-height: 34px;
      font-weight: bold;
    }
    p{
      font-size: 14px;
      line-height: 24px;
    }
  }
  .formTab{
      // border-top: 2px solid #E4E7ED;
      /deep/.el-tabs__item{
          padding: 0 20px;
          font-size: 16px;
          height: 50px;
          line-height: 50px;
          color: rgba(56, 56, 56, 1);
      }
      /deep/.selectForm{
          .el-form-item{
              margin-right: 5%;
          }
          .el-date-editor .el-range-separator{
              width: 10%;
          }
      }
      .formInline{
        display: flex;
        flex-direction: row;
        .el-form-item{
          flex: 1;
          margin-right: 30px;
        }
      }
      .baseForm{
        /deep/.el-form-item__content{
          .el-cascader,.el-date-editor{
            width: 100%;
          }
        }
      }
      .manageForm,.scientificForm{
        .formInline{
          /deep/.el-form-item{
            .el-form-item__label{
              width: 150px !important;
            }
            .el-form-item__content{
              margin-left: 150px !important;
            }
          }
        }
      }
  } 
}
</style>
